import React, { useState, useEffect } from 'react';
import { ExpenseCategory, CreateExpenseCategoryRequest, UpdateExpenseCategoryRequest } from '../types';

interface ExpenseCategoryFormProps {
    category?: ExpenseCategory | null;
    onSubmit: (data: CreateExpenseCategoryRequest | UpdateExpenseCategoryRequest) => void;
    onCancel: () => void;
}

const ExpenseCategoryForm: React.FC<ExpenseCategoryFormProps> = ({ category, onSubmit, onCancel }) => {
    const [name, setName] = useState('');

    useEffect(() => {
        setName(category?.name ?? '');
    }, [category]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!name.trim()) return;
        onSubmit({ name: name.trim() });
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <label htmlFor="name" className="block text-sm font-medium text-secondary-700 mb-1">
                    Nome *
                </label>
                <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    maxLength={100}
                    className="input-field"
                    placeholder="Ex.: Mercado, Transporte..."
                />
            </div>
            <div className="flex justify-end space-x-3 pt-4">
                <button type="button" onClick={onCancel} className="btn-secondary">
                    Cancelar
                </button>
                <button type="submit" className="btn-primary">
                    {category ? 'Salvar' : 'Criar'}
                </button>
            </div>
        </form>
    );
};

export default ExpenseCategoryForm;
